<div class="filter-dialog">
  <div class="dialog-header">
    <h2 class="dialog-title">{{ data.title }}</h2>
    <button class="close-btn" (click)="onCancel()">
      <img src="/assets/images/close.svg" alt="close" width="16" height="16">
    </button>
  </div>
  
  <div class="dialog-content">
    <div class="filter-field" *ngFor="let field of data.filters">
      <label class="filter-label">{{ field.label }}</label>
      
      <!-- Text Input -->
      <input 
        *ngIf="field.type === 'text'"
        type="text" 
        class="filter-input"
        [(ngModel)]="filters[field.key]"
        [placeholder]="field.placeholder || 'Enter ' + field.label"
      />
      

      <!-- Business Dropdown -->
      <ng-select
        *ngIf="field.key === 'business_id'"
        [items]="businessList"
        bindLabel="name"
        bindValue="id"
        [(ngModel)]="filters.business_id"
        [placeholder]="field.placeholder || 'Select Business'"
        [clearable]="!!filters.business_id"
        class="filter-select"
        appendTo="body"
        (change)="onBusinessChange(filters.business_id)"
      >
      </ng-select>

      <!-- Department Dropdown (dependent) -->
      <ng-select
        *ngIf="field.key === 'department_id'"
        [items]="departmentOptions"
        bindLabel="label"
        bindValue="value"
        [(ngModel)]="filters.department_id"
        [placeholder]="field.placeholder || 'Select Department'"
        [clearable]="!!filters.department_id"
        class="filter-select"
        appendTo="body"
        [disabled]="departmentDisabled"
      >
      </ng-select>

      <!-- Other Select Dropdowns -->
      <ng-select
        *ngIf="field.type === 'select' && field.key !== 'business_id' && field.key !== 'department_id'"
        [items]="field.options"
        bindLabel="label"
        bindValue="value"
        [(ngModel)]="filters[field.key]"
        [placeholder]="field.placeholder || 'Select ' + field.label"
        [clearable]="!!filters[field.key]"
        class="filter-select"
        appendTo="body"
      >
      </ng-select>
      
      <!-- Date Input -->
      <input 
        *ngIf="field.type === 'date'"
        type="date" 
        class="filter-input"
        [(ngModel)]="filters[field.key]"
      />
      
      <!-- Date Range -->
      <div *ngIf="field.type === 'dateRange'" class="date-range">
        <input 
          type="date" 
          class="filter-input date-input"
          [(ngModel)]="filters[field.key + '_start']"
          placeholder="Start Date"
        />
        <span class="date-separator">to</span>
        <input 
          type="date" 
          class="filter-input date-input"
          [(ngModel)]="filters[field.key + '_end']"
          placeholder="End Date"
        />
      </div>
    </div>
  </div>
  
  <div class="dialog-actions">
    <button class="btn btn-secondary" (click)="onClearFilters()">
      Remove All Filters
    </button>
    <button class="btn btn-primary" (click)="onApplyFilters()">
      Apply
    </button>
  </div>
</div>